import { render } from "./ForeignTable.vue?vue&type=template&id=05cdfec4"
import script from "./ForeignTable.vue?vue&type=script&lang=js"
export * from "./ForeignTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__